export const REDIRECT_TO_HOME = '@auth/REDIRECT_TO_HOME';
export const REDIRECT_TO_SIGN_IN = '@auth/REDIRECT_TO_SIGN_IN';
export const REDIRECT_TO_ROUTE = '@auth/REDIRECT_TO_ROUTE';

export const redirectToHome = () => ({
    type: REDIRECT_TO_HOME,
    payload: {},
});

export const redirectToSignIn = () => ({
    type: REDIRECT_TO_SIGN_IN,
    payload: {},
});

export const redirectToRoute = ({ route }) => ({
    type: REDIRECT_TO_ROUTE,
    payload: { route },
});
